import * as React from 'react';
import { styled } from 'styled-components';
import HeaderCardSection from '../common/HeaderCardSection';
import { BbocResult } from '../../../core/bbocResultData';
import LessonCard from '../common/Cards/Progress12/LessonCard';
import { slateGrey } from '../../cssConstants';
import { OldCardContainer } from '../common/CardLayout';

const BbocTakeActionSubPage = ({ bboc }: { bboc: BbocResult }) => {
	return (
		<>
			<CardContainerWrapper>
				<HeaderCardSection
					title={`What does ${bboc.title} mean?`}
					descriptions={bboc.description}
					descriptionFontSize="12px"
				/>
			</CardContainerWrapper>
			<ActionItemsWrapper>
				<CardTitle>Action items</CardTitle>
				{bboc.actionItems.map((item) => (
					<LessonCard
						key={item.id}
						id={item.id}
						imageSrc={item.image}
						title={item.title}
						description={item.description}
						imageSize={{ width: '70px', height: '70px' }}
					/>
				))}
			</ActionItemsWrapper>
		</>
	);
};

export default BbocTakeActionSubPage;

const ActionItemsWrapper = styled.div`
	margin-bottom: 16px;
`;

// padding y needs 24px and there is already 16px from CardContainer
const CardContainerWrapper = styled(OldCardContainer)`
	padding: 0 16px;
`;

const CardTitle = styled.p`
	color: ${slateGrey};
	font-size: 16px;
	font-weight: 500;
	letter-spacing: 0.15px;
`;
